
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _403_45GuPeWBZ1T_45clkWk_WG_45ZLXvv9u0zl4Yof5a_45HhUcVYMeta } from "/app/pages/403.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as callbackpP4QV_45aDBAaDodrISXkTgcnAismuCak5ttSJOC_45p1sMMeta } from "/app/pages/callback.vue?macro=true";
import { default as silent_45callbackq49fW3X2CwZME_rHyHPuxduMwbyExBbPPaqIsztbhdgMeta } from "/app/pages/silent-callback.vue?macro=true";
import { default as maintenance_45planner7j3gkNSrGtMuiz9FzWpuiHNNmXFnUil_iEvvKlBgzC8Meta } from "/app/pages/maintenance-planner.vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    component: () => import("/app/pages/403.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "callback",
    path: "/callback",
    component: () => import("/app/pages/callback.vue")
  },
  {
    name: "silent-callback",
    path: "/silent-callback",
    component: () => import("/app/pages/silent-callback.vue")
  },
  {
    name: "maintenance-planner",
    path: "/maintenance-planner",
    meta: {"middleware":"groups"},
    component: () => import("/app/pages/maintenance-planner.vue")
  }
]